import { render } from "./watchlist-widget.vue?vue&type=template&id=ba49ce32"
import script from "./watchlist-widget.vue?vue&type=script&lang=js"
export * from "./watchlist-widget.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__